import React from 'react';
import JobPortal from './components/JobPortal';
import './App.css';

function App() {
  return (
    <div className="App">
      <JobPortal />
    </div>
  );
}

export default App;
